@keyframes blend {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.cast-connecting g:not(:nth-child(1)) {
  animation-name: blend;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-direction: alternate;
  opacity: 0;
}
.cast-connecting {
  & g:nth-child(2) {
    animation-delay: 250;
  }
  & g:nth-child(3) {
    animation-delay: 500;
  }
  & g:nth-child(4) {
    animation-delay: 750;
  }
}

.play-round {
  & circle {
    fill: var(--rds-accent-color);
  }
  & path {
    fill: var(--rds-button-primary-fg);
  }
}
